import React, { Component } from "react";
import { observer } from "mobx-react";
import { fn_salesNextPage, fn_salesPrevPage } from "function/FnBodySales";

@observer
class SalesPagingBottomView extends Component {
    render() {

        const { rootStore } = this.props;
        const salesStore = rootStore.salesStore;

        return (
            <div className="paging sales">
                <button type="button" className="prev" disabled={salesStore.getSalesPaging.sales_page_no === 1 ? "disabled" : ""}
                    onClick={(evnet) => fn_salesPrevPage(rootStore)}
                ><span>이전 페이지</span></button>
                <p className="number">
                    <strong><span className="screen_out">현재 페이지</span>{salesStore.getSalesPaging.sales_page_no} </strong>
                    /
                    <span className="screen_out">전체 페이지</span> {salesStore.getSalesPaging.sales_max_page}
                </p>
                <button type="button" className="next" disabled={salesStore.getSalesPaging.sales_page_no === salesStore.getSalesPaging.sales_max_page ? "disabled" : ""}
                    onClick={(evnet) => fn_salesNextPage(rootStore)}
                ><span>다음 페이지</span></button>
            </div>
        );
    }
}

export default SalesPagingBottomView;